import React, { useState } from 'react';

const Step3_Preview = ({ clinicId, mappings, onBack, onNext, error, setError }) => {
  const [edits, setEdits] = useState(() => {
    const m = {};
    mappings.forEach((x, i) => {
      m[i] = x.service_provided;
    });
    return m;
  });

  const handleEdit = (idx, value) => {
    setEdits((prev) => ({ ...prev, [idx]: value }));
  };

  const handleNext = () => {
    const updated = mappings.map((m, i) => ({
      ...m,
      service_provided: edits[i] ?? m.service_provided,
    }));
    onNext({ clinicId, mappings: updated });
  };

  return (
    <div className="space-y-6">
      <div className="text-center">
        <h2 className="text-2xl font-bold text-gray-900 mb-2">Step 3: Preview & Edit</h2>
        <p className="text-gray-600">
          Review before/after. Edit the new service_provided if needed.
        </p>
      </div>

      <div className="space-y-4">
        {mappings.map((m, idx) => (
          <div key={idx} className="bg-white border border-gray-200 rounded-lg p-4">
            <h3 className="font-medium text-gray-900 mb-2">{m.doctor.primary_name}</h3>
            <div className="grid grid-cols-1 md:grid-cols-2 gap-4 text-sm">
              <div>
                <label className="block font-medium text-gray-600 mb-1">Before</label>
                <div className="p-2 bg-gray-50 rounded border border-gray-200 whitespace-pre-wrap">
                  {m.doctor.service_provided || '(empty)'}
                </div>
              </div>
              <div>
                <label className="block font-medium text-gray-600 mb-1">After</label>
                <textarea
                  value={edits[idx] ?? m.service_provided}
                  onChange={(e) => handleEdit(idx, e.target.value)}
                  className="w-full p-2 border border-gray-300 rounded min-h-[80px]"
                  rows={3}
                />
              </div>
            </div>
          </div>
        ))}
      </div>

      {error && (
        <div className="bg-red-50 border border-red-200 rounded-lg p-4 text-red-800">{error}</div>
      )}

      <div className="flex justify-between">
        <button
          onClick={onBack}
          className="px-6 py-3 bg-gray-300 text-gray-700 rounded-md hover:bg-gray-400 font-medium"
        >
          Back
        </button>
        <button
          onClick={handleNext}
          className="px-8 py-3 bg-blue-600 text-white rounded-md hover:bg-blue-700 font-medium"
        >
          Confirm & Update
        </button>
      </div>
    </div>
  );
};

export default Step3_Preview;
